import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { FaCopy } from 'react-icons/fa'; 

interface EmailCellRendererProps extends ICellRendererParams {
    value: string;
}

// Cast esplicito per TS
const FaCopyIcon = FaCopy as unknown as React.FC<{ size?: number }>;

const EmailCellRenderer: React.FC<EmailCellRendererProps> = (props) => {
    const email = props.value;

    const handleCopy = React.useCallback(
        (e: React.MouseEvent) => {
            e.stopPropagation();
            if (email) {
                navigator.clipboard.writeText(email).then(
                    () => console.log(`Email ${email} copiata!`),
                    (err) => console.error('Errore nella copia: ', err)
                );
            }
        },
        [email]
    );

    if (!email) return null;

    return (
        <div style={{ 
            display: 'flex', 
            justifyContent: 'flex-end', 
            alignItems: 'center', 
            maxWidth: 60 ,
            height: '100%' 
        }}>
            <a
                //href={`mailto:${email}`}
                href={`mailto:${email}?subject=Oggetto%20della%20mail&body=Testo%20predefinito`}
                onClick={(e) => e.stopPropagation()}
                style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                    color: "#A0C4FF",
                    fontWeight: "normal",
                    fontSize: "0.85rem",
                    marginRight: '8px'
                }}
            >
                Email
            </a>
            
            <button
                onClick={handleCopy}
                style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '0 4px',
                    color: 'grey',
                    display: 'flex',
                    alignItems: 'center'
                }}
                title={`Copia l'email: ${email}`}
            >
                <FaCopyIcon size={12} /> {/* ✅ Cast per TS */}
            </button>
        </div>
    );
};

export default EmailCellRenderer;
